module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 10
// module chunks = 0